import styles from "./CreateLastMinuteDeal.module.scss";
import React, { useEffect, useRef } from "react";
import { useGetLastMinuteDealByIdQuery } from "../../../api/queries";
import Loader from "../../../components/Loader/Loader";
import { Form, FormInstance } from "antd";
import FormItemInputNumber from "../../../components/ui/FormItemInputNumber/FormItemInputNumber";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import percentIcon from "../../../assets/images/icons/percent-black.svg";
import { ILastMinuteDealCreateModel } from "../../../models/LastMinuteDeal";
import MainTitle from "../../../components/ui/MainTitle/MainTitle";
import { useLastMinuteDealMutations } from "../../../api/mutations";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { openSuccessMessage } from "../../../store/message/messageSlice";
import { handleError } from "../../../helper/errorHandler";

interface ICreateLastMinuteDealProps {
  id: string | "new";
  refetch: () => void;
  closePopup: () => void;
}

const CreateLastMinuteDeal: React.FC<ICreateLastMinuteDealProps> = ({
  id,
  refetch,
  closePopup,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const formRef = useRef<FormInstance>(null);
  const { data, isLoading } = useGetLastMinuteDealByIdQuery(id!);
  const { create, update } = useLastMinuteDealMutations();

  useEffect(() => {
    if (formRef.current && data) {
      formRef.current.setFieldsValue({
        hoursBeforeClass: data.hoursBeforeClass,
        discountPercent: data.discountPercent,
      });
    }
  }, [data, formRef]);

  const onFinish = (values: ILastMinuteDealCreateModel) => {
    if (id === "new") {
      create(values, {
        onSuccess: () => {
          refetch();
          closePopup();
          dispatch(openSuccessMessage("LastMinuteDealRuleCreatedSuccessfully"));
        },
        onError: (e) => handleError(e, dispatch, t),
      });
    } else {
      update(
        { id, model: values },
        {
          onSuccess: () => {
            refetch();
            closePopup();
            dispatch(openSuccessMessage("LastMinuteDealRuleUpdatedSuccessfully"));
          },
          onError: (e) => handleError(e, dispatch, t),
        }
      );
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <MainTitle size={20} text={t("LastMinuteDeal")} />
        <Form
          ref={formRef}
          name="create-last-minute"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemInputNumber
            name={"hoursBeforeClass"}
            label={t("TimeBeforeClass")}
            rules={{ required: true }}
          />

          <FormItemInputNumber
            name={"discountPercent"}
            label={t("PercentAmount")}
            rules={{ required: true }}
            prefix={percentIcon}
          />

          <div className={styles.btnWrapper}>
            <CustomButton
              text={t("Close")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={closePopup}
            />
            <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateLastMinuteDeal;
